import styled from 'styled-components';

const Container = styled.div`
  height: 170px;
  overflow: hidden;
  position: relative;
  background-color: ${({ theme }) => theme.colors.corporateWhite};

  .header_image {
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    width: 100%;
  }

  .header_image_shelves {
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export default Container;
